import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import CONFIG from '../../app-configs'
import { ApiAuthStrategies } from '../shared/ApiAuthStrategies'
import { adhocDistributionApiMapper } from './adhocDistributionApiMapper'
import { type PendingAdhocDistributionSummary } from '../../api-schema-types/asset-holdings/AdhocDistributionCrudDtos'

export const adhocDistributionApi = createApi({
  reducerPath: 'adhocDistributionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}/asset-holdings/adhoc-distributions`,
    prepareHeaders: (headers: Headers, { getState }) => {
      const authToken = ApiAuthStrategies.getBearerTokenHeader()
      headers.set('authorization', authToken)
      return headers
    }
  }),
  endpoints: (builder) => ({
    getPendingAdhocDistributionSummary: builder.query({
      query: () => ({
        url: '/pending'
      }),
      transformResponse: (response: PendingAdhocDistributionSummary, meta, arg) => adhocDistributionApiMapper().pendingAdhocDistributionSummaryMapper(response, meta, arg)
    })
  })
})

export const useGetPendingAdhocDistributionSummaryQuery = adhocDistributionApi.endpoints.getPendingAdhocDistributionSummary.useQuery
